// extracted by mini-css-extract-plugin
export default {"container":"withdrawal_container__BbLpv","title":"withdrawal_title__Fk8CR","imgContainer":"withdrawal_imgContainer__Jjy0l"};